import React, { useState, useEffect } from "react";

import useInterval from "@rooks/use-interval";
import axios from "../../../api/axios";
import MultiBarChartComponent from "../MultiBarChartComponent";
import SvgComponent from "../SvgComponent";

var request_updateTimelineData_safe = true;

function getLocalHour(date) {
  if (date) {
    let hour = new Date(date).getHours();
    return hour < 10 ? `0${hour}:00` : `${hour}:00`;
  }
}

function findHourData(timeline, hour, device) {
  for (let i = 0; i < timeline.length; i++) {
    if (timeline[i]["hour"] === hour) {
      return { success: 1, timeline: timeline[i] };
    }
  }
  return { success: -1, hour, timeline: timeline[0], [device]: 0 };
}

// function margeSameHours(timeline) {
//   let temp = [];
//   for (let i = 0; i < timeline.length; i++) {
//     let currentChecker = timeline[i];
//     let deviceId = currentChecker["deviceId"];

//     for (let j = i + 1; j < timeline.length; j++) {
//       if (
//         parseInt(timeline[i]["hour"].split(":")[0]) ===
//           parseInt(timeline[j]["hour"].split(":")[0]) &&
//         currentChecker["deviceId"] === timeline[j]["deviceId"]
//       ) {
//         currentChecker[deviceId] =
//           currentChecker[deviceId] + timeline[j][deviceId];
//       }
//     }
//     temp.push(currentChecker);
//   }

//   return temp;
// }
function margeSameHours(timeline) {
  let hours = new Set();
  let data = [];
  for (let i = 0; i < timeline.length; i++) {
    if (i === 0) {
      hours.add(timeline[i]["hour"]);
      let currentChecker = timeline[i];
      for (let j = 1; j < timeline.length; j++) {
        if (currentChecker["hour"] === timeline[j]["hour"]) {
          currentChecker["leaving"] += timeline[j]["leaving"];
          currentChecker["entering"] += timeline[j]["entering"];
          currentChecker["total"] =
            timeline[j]["total"] + currentChecker["total"];
        }
      }
      data.push(currentChecker);
    } else if (!hours.has(timeline[i]["hour"])) {
      hours.add(timeline[i]["hour"]);
      let currentChecker = timeline[i];
      for (let j = i + 1; j < timeline.length; j++) {
        if (currentChecker["hour"] === timeline[j]["hour"]) {
          currentChecker["leaving"] += timeline[j]["leaving"];
          currentChecker["entering"] += timeline[j]["entering"];
          currentChecker["total"] =
            timeline[j]["total"] + currentChecker["total"];
        }
      }
      data.push(currentChecker);
    } else continue;
  }
  return data.sort(
    (a, b) =>
      new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        parseInt(a["hour"].split(".")[0])
      ) -
      new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        parseInt(a["hour"].split(".")[0])
      )
  );
}

function fillLine(timeline, isEmpty = false) {
  let temp = [];
  // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
  if (!isEmpty) {
    for (let i = 0; i <= new Date().getHours(); i++) {
      let hour = i < 10 ? `0${i}:00` : `${i}:00`;
      let res = findHourData(timeline, hour);
      if (res.success !== -1) {
        temp.push(res.timeline);
      } else {
        let obj = {
          hour: hour,
          leaving: 0,
          entering: 0,
          total: 0,
        };

        temp.push(obj);
      }
    }
  } else {
    for (let i = 0; i <= new Date().getHours(); i++) {
      let hour = i < 10 ? `0${i}:00` : `${i}:00`;
      let obj = {
        hour: hour,
        leaving: 0,
        entering: 0,
        total: 0,
      };
      temp.push(obj);
    }
  }

  return temp;
}

const YsbHourlyBarChartComponent = ({ token, areas }) => {
  const [timelineData, setTimelineData] = useState([]);
  const [deviceKeys, setDeviceKeys] = useState([]);
  const [loadingChart, setLoadingChart] = useState(true);

  const colors = ["#55b8ba", "#6363FF"];
  const svgColors = ["#55b8ba", "#6363FF"];
  const colorTexts = [
    "text-cyan-700",
    "text-blue-700",
    "text-purple-400",
    "text-green-700",
  ];
  const textDescription = ["Entering", "Leaving"];
  const textChartDescription = ["Leaving 1 ", "Kineret 2 "];

  function getDeviceNames() {
    let map = new Map();
    Array.from(areas).forEach((area) => {
      Array.from(area.devices).forEach((device) => {
        map.set(device.deviceId, device.name);
      });
    });
    // let devices = [...map.keys()];
    let devices = ["entering", "leaving"];
    setDeviceKeys((prev) => devices);
  }
  // function testDataTimeLine() {
  //   let data = [];
  //   let hour = new Date().getHours();

  //   for (let index = 0; index < deviceKeys.length; index++) {
  //     const device = deviceKeys[index];
  //     for (let index = hour; index >= 0; index--) {
  //       let date = new Date();
  //       date.setHours(index);
  //       // let id = device.slice(10);
  //       // let keys = [`entering-${id}`, `leaving-${id}`];
  //       let obj = {
  //         deviceId: device,
  //         hour: getLocalHour(date),
  //         hourBalance: Math.floor(Math.random() * 500),
  //         [device]: Math.floor(Math.random() * 500),
  //         total: Math.floor(Math.random() * 500),
  //       };
  //       data.push(obj);
  //     }
  //   }
  //   data = margeSameHours(data);
  //   // data = fillLine(data);
  //   // setTimelineData((prev) => data);
  //   setTimelineData((prev) => data);
  //   setLoadingChart(false);
  // }

  function updateTimelineDataBar() {
    if (request_updateTimelineData_safe === false) {
      return;
    } else {
      request_updateTimelineData_safe = false;
    }
    axios
      .get(
        `/v1/statistics/hour?token=${token}&day=${new Date().getUTCDate()}&month=${
          new Date().getUTCMonth() + 1
        }&areas=${null}`
      )
      .then((res) => {
        let resData = [];
        let data = res.data.flat();
        let devices = [
          ...new Set(
            data.map((obj) => {
              return obj["deviceId"];
            })
          ),
        ];
        for (let j = 0; j < data.length; j++) {
          // console.log(parseInt(res.data[i][j]["hour"].split(":")[0]));
          let deviceId = data[j]["deviceId"];
          let hour = new Date(data[j]["date"]).getHours();
          // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
          if (hour <= new Date().getHours()) {
            let id = deviceId.slice(10);
            let keys = [`entering-${id}`, `leaving-${id}`];
            let sum = data[j]["vehiclesCount"];
            let obj = {
              deviceId: deviceId,
              hour: getLocalHour(data[j]["date"]),
              keys: keys,
              leaving:
                deviceId === "600a0c2a69e812dc" ||
                deviceId === "600a0c2a69e808f0"
                  ? sum
                  : 0,
              entering:
                deviceId === "600a0c2a69e811c8" ||
                deviceId === "600a0c2a69e816da"
                  ? sum
                  : 0,
              total: sum,
            };

            resData.push(obj);
          }
        }
        if (resData.length > 0) {
          resData = margeSameHours(resData);
          resData = fillLine(resData);
        } else {
          resData = fillLine(resData, true);
        }

        setTimelineData((prev) => resData);
        setLoadingChart(false);
        request_updateTimelineData_safe = true;
      })
      .catch((err) => {
        console.log(
          "error with get hour statistic inside today vehicles-> ",
          err
        );
        request_updateTimelineData_safe = true;
      });
  }
  useEffect(() => {
    // updateTimelineData();
    getDeviceNames();
    updateTimelineDataBar();

    // setTimeout(() => {
    //   testDataTimeLine();
    // }, 5000);

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Get the up-to-date data for the in-out chart every 1 sec
  useInterval(
    () => {
      updateTimelineDataBar();
      return () => {};
    },
    10501,
    true
  );

  if (loadingChart) {
    return (
      <div className="flex justify-center ">
        <div className="bg-gray-300  w-full px-4  h-100 rounded-md overflow-hidden transition-all">
          <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
        </div>
      </div>
    );
  }
  return (
    <div className="h-full">
      <SvgComponent
        description={textDescription}
        svgColor={svgColors}
        textColor={colorTexts}
      />
      <MultiBarChartComponent
        // key={deviceKeys}
        devices={deviceKeys}
        data={timelineData}
        colorGraph={colors}
        colorText={colorTexts}
        textDescription={textChartDescription}
        isCustomTooltip={true}
      />
    </div>
  );
};
export default YsbHourlyBarChartComponent;
